require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./financial-education-banzai-coaches.json") })
        }
      }, "path---financial-education-banzai-coaches");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---financial-education-banzai-coaches!./.cache/json/financial-education-banzai-coaches.json
// module id = 2632
// module chunks = 231608221292675